import React, { Fragment } from 'react';


class Organization extends React.Component{
  render(){
    return <Fragment>
      <p>
        OVC is a science and technology investment company dedicated to
        articulating and presenting proprietary innovations and products originating from top-tier
        and prominent research universities. It is based in London, with associates operating in
        the US, China, and Hong Kong. The business objective is to commercialize state-of-the-art
        innovations in medicine, bioscience, smart mobility programs, financial and
        transactional technologies including artificial intelligence, and sustainable energy
        designs.
      </p>
      </Fragment>;
  }
}

export default Organization;
